import React, { useState } from 'react';
import OrderForm from '../../components/OrderForm';
import { Confirmation } from '../../components/Confirmation';
import styles from './Registration.module.scss';

interface RegistrationProps {
  type: "us" | "international";
  purchaseSources: {
    name: string;
    value: string;
    default?: boolean;
  }[];
}

const Registration = ({
  type,
  purchaseSources
}: RegistrationProps) => {
  const [subscriptionCreated, setSubscriptionCreated] = useState(false);
  const [alreadySubscribed, setAlreadySubscribed] = useState<boolean>(false);
  const [giftedMonths, setGiftedMonths] = useState(0);

  const handleSubscriptionCreated = (subscriptionExists = false, giftedMonths = 0) => {
    setAlreadySubscribed(subscriptionExists);
    setSubscriptionCreated(true);
    setGiftedMonths(giftedMonths);
  };

  return (
    <>
      {subscriptionCreated ? (
        alreadySubscribed ? (
          <Confirmation
            title="We couldn’t activate your membership"
            cta="contactSupport"
            hideIcon
            parentPage="register"
          >
            <p>
              There’s already an active subscription tied to this email. Contact support to activate your Tempo Move or
              Studio.
            </p>
          </Confirmation>
        ) : (
          <Confirmation title="You’re all set!" cta="deepLink" parentPage="register">
            <p>
              Your membership will start once you receive and activate your Tempo.
              {giftedMonths > 0 && `Free gifted months will be applied when you activate your device.`}
            </p>
          </Confirmation>
        )
      ) : (
        <div className={styles.container}>
          <OrderForm onComplete={handleSubscriptionCreated} type={type} purchaseSources={purchaseSources} />
        </div>
      )}
    </>
  );
};

export default Registration;

